<template>
  <div id="app">
    <v-app>
      <page-header v-if="!$store.state.isAdminLoggedIn && !$store.state.isTrainerLoggedIn" />
      <admin-header v-else />
       <logout-timer/>
      <main>
        <v-container fluid>
          <router-view/>
        </v-container>
      </main>
    </v-app>
  </div>
</template>

<script>
import PageHeader from '@/components/Header'
import AdminHeader from '@/components/Admin/AdminHeader.vue'
import LogoutTimer from '@/components/LogoutTimer.vue'
export default {
  name: 'App',
  components:{
    PageHeader,
    AdminHeader,
    LogoutTimer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.input-group--text-field input {
  border-bottom: 1px;
}
.danger-alert{
  color:red;
}
.sv_complete_btn {
  background-color:#007bff;
  color: white
}

</style>
